<div [style.width]="diameter()" [style.height]="diameter()"></div>
